import React, { useState, useEffect } from 'react';
import { Stack } from 'react-bootstrap';
import { useJobAppliedQuery } from 'services';
import ReactSelect from 'react-select';
import PaginationBox from 'components/PaginationBox';
import { commonSortingOptions, dataLimits } from 'constants/index';
import JobListingBox from 'components/Common/Jobs/JobListingBox';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import useLocalizationStore from 'store/localization';

const AppliedJobs: React.FC = () => {
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState(1);
	const { activeLanguage }: any = useLocalizationStore((state) => state);
	const [orderBy, setOrderBy] = useState('createdAt');
	const [order, setOrder] = useState('DESC');

	const queryOptions = `limit=${dataLimits?.appliedJobs}&page=${currentPage}&orderBy=${orderBy}&order=${order}`;
	const { data: { docs: jobs = [], meta = {} } = [], refetch } = useJobAppliedQuery(queryOptions);
	const { limit = 10, totalDocs } = meta;

	useEffect(() => {
		refetch();
	}, [currentPage, orderBy, order, activeLanguage]);

	return (
		<div className="right-area flex-1 d-flex flex-column">
			<div className="white-box bg-white">
				<Stack className="gap-4">
					<div className="jobs-filter d-flex align-items-center justify-content-between">
						<p className="fw-semibold mb-0">{translate('JobDetailBox.appliedJobs')}</p>
						<div className="sort-box d-flex align-items-center">
							<h6 className="mb-0">
								<i className="ri-filter-3-line position-relative"></i>{' '}
								{translate('JobDetailBox.sortBy')}
							</h6>
							<ReactSelect
								className="sort-select"
								classNamePrefix="select"
								placeholder={translate('PlaceHolder.newest')}
								autoFocus={false}
								isSearchable={false}
								options={commonSortingOptions(translate)}
								getOptionLabel={(option: any) => option?.label}
								getOptionValue={(option: any) => option?.value}
								onChange={(value: any) => {
									setOrderBy(value?.orderBy);
									setOrder(value?.order);
								}}
							/>
						</div>
					</div>
					{jobs?.length > 0 ? (
						jobs.map((job: any, index: number) => (
							<JobListingBox
								job={job}
								key={index}
								refetch={refetch}
								dataLength={jobs?.length}
								currentPage={currentPage}
								setCurrentPage={setCurrentPage}
								enableFavBtn={false}
							/>
						))
					) : (
						<Stack className="posted-job-box">
							<p className="mb-0">{translate('Common.noJobsFound')}</p>{' '}
						</Stack>
					)}
				</Stack>

				{totalDocs > limit && (
					<PaginationBox
						totalData={totalDocs}
						limit={limit}
						page={currentPage}
						setCurrentPage={setCurrentPage}
					/>
				)}
			</div>
		</div>
	);
};

export default AppliedJobs;
